import React from 'react'
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import {
  PurchasePage,
  PurchasePageTemplate,
} from 'Event/Marketplace/purchase-page'
import {ThankYouPageTemplate} from 'Event/Marketplace/thank-you-page'
import {UpsellPageTemplate} from 'Event/Marketplace/upsell-page'
import ConfigPage from 'organization/Marketplace/config/ConfigPage'
import {useUpdateTemplate} from 'organization/Marketplace/PurchasePageConfig/PurchasePageTemplateUpdateProvider'
import {orderedIdsByPosition} from 'Event/Marketplace/lib/list'
import PreviewButton from 'organization/Marketplace/PurchasePageConfig/PreviewButton'
import PurchasePageButtonConfig from 'organization/Marketplace/config/BlockConfig/PurchasePageButtonConfig'
import {useEvent} from 'Event/EventProvider'
import PurchasePageTemplateSelector from 'organization/Marketplace/config/TemplateSelector/PurchasePageTemplateSelector'
import {Client} from 'lib/ui/api-client'
import {useUpdatePurchasePage} from 'lib/marketplace-api/purchase-page/use-update-purchase-page'
import MissingRequiredBlocksAlert from 'organization/Marketplace/PurchasePageConfig/MissingRequiredBlocksAlert'
import ClearTemplateButton from './ClearTemplateButton'

interface ContentProps {
  purchasePage: PurchasePage
  template: PurchasePageTemplate | ThankYouPageTemplate | UpsellPageTemplate
  client: Client
}

export default function PurchasePageConfigContent(props: ContentProps) {
  const {template, purchasePage, client} = props
  const {event} = useEvent()
  const updateTemplate = useUpdateTemplate()

  const {sections} = template

  const sectionIds = orderedIdsByPosition(sections)
  const hasSections = sectionIds.length > 0

  const updatePurchasePage = useUpdatePurchasePage({client, purchasePage})

  const setEnabled = (enabled: boolean) => {
    updatePurchasePage.mutateAsync({is_enabled: enabled})
  }

  if (!hasSections) {
    return <PurchasePageTemplateSelector updateTemplate={updateTemplate} />
  }

  const marketplaceStoreUrl = process.env.REACT_APP_MARKETPLACE_STORE_APP_URL

  const copyButton = {
    value: `${marketplaceStoreUrl}/${event.slug}`,
    tooltip: 'Copy Purchase Page URL',
  }

  return (
    <>
      <ConfigPage
        template={template}
        updateTemplate={updateTemplate}
        availableBlocks={[
          'Title',
          'Text',
          'Image',
          'Video',
          'Button',
          'TicketSelector',
          'PurchaseForm',
          'BulletedList',
          'NumberedList',
          'FaqList',
          'CountdownTimer',
          'Icon',
          'Separator',
          'Grid',
          'Spacer',
        ]}
        rightToolbarItems={
          <>
            <ClearTemplateButton updateTemplate={updateTemplate} />
            <PreviewButton />
          </>
        }
        ButtonConfig={PurchasePageButtonConfig}
        copyButton={copyButton}
        enabled={purchasePage.is_enabled}
        setEnabled={setEnabled}
        disableEnableToggle={updatePurchasePage.isLoading}
      />
      <MissingRequiredBlocksAlert template={template} />
    </>
  )
}
